import {
  GET_BADGE_LIST_FAIL,
  GET_BADGE_LIST_REQUEST,
  GET_BADGE_LIST_SUCCESS,
  CREATE_BADGE_REQUEST,
  CREATE_BADGE_SUCCESS,
  CREATE_BADGE_FAIL,
  UPDATE_BADGE_REQUEST,
  UPDATE_BADGE_SUCCESS,
  UPDATE_BADGE_FAIL,
  DELETE_BADGE_REQUEST,
  DELETE_BADGE_SUCCESS,
  DELETE_BADGE_FAIL,
  GET_CERTIFICATE_LIST_REQUEST,
  GET_CERTIFICATE_LIST_SUCCESS,
  GET_CERTIFICATE_LIST_FAIL,
  CREATE_CERTIFICATE_REQUEST,
  CREATE_CERTIFICATE_SUCCESS,
  CREATE_CERTIFICATE_FAIL,
  UPDATE_CERTIFICATE_REQUEST,
  UPDATE_CERTIFICATE_SUCCESS,
  UPDATE_CERTIFICATE_FAIL,
  DELETE_CERTIFICATE_REQUEST,
  DELETE_CERTIFICATE_SUCCESS,
  DELETE_CERTIFICATE_FAIL,
  UPLOAD_CERTIFICATE_TEMPLATE_REQUEST,
  UPLOAD_CERTIFICATE_TEMPLATE_SUCCESS,
  UPLOAD_CERTIFICATE_TEMPLATE_FAIL,
  CREATE_CERTIFICATE_CRITERIA_FAIL,
  CREATE_CERTIFICATE_CRITERIA_REQUEST,
  CREATE_CERTIFICATE_CRITERIA_SUCCESS,
  DELETE_CERTIFICATE_CRITERIA_FAIL,
  DELETE_CERTIFICATE_CRITERIA_REQUEST,
  DELETE_CERTIFICATE_CRITERIA_SUCCESS,
  GET_CERTIFICATE_CRITERIA_BY_ID_FAIL,
  GET_CERTIFICATE_CRITERIA_BY_ID_REQUEST,
  GET_CERTIFICATE_CRITERIA_BY_ID_SUCCESS,
  GET_CERTIFICATE_CRITERIA_LIST_FAIL,
  GET_CERTIFICATE_CRITERIA_LIST_REQUEST,
  GET_CERTIFICATE_CRITERIA_LIST_SUCCESS,
  UPDATE_CERTIFICATE_CRITERIA_FAIL,
  UPDATE_CERTIFICATE_CRITERIA_REQUEST,
  UPDATE_CERTIFICATE_CRITERIA_SUCCESS,
} from "../../Constants/RewardConstants";

const initialStateDefault = {
  status: false,
  data: { rows: [], count: 0 },
  loading: true,
  error: null,
};

const initialStateSimple = {
  status: false,
  data: null,
  loading: true,
  error: null,
};

export const BadgeListReducer = (state = initialStateDefault, action: any) => {
  try {
    if (action.type === GET_BADGE_LIST_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === GET_BADGE_LIST_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }

    if (action.type === GET_BADGE_LIST_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: { rows: [], count: 0 },
      };
    }
  } catch (error) {}
  return state;
};

export const BadgeCreateReducer = (
  state = initialStateSimple,
  action: any
) => {
  try {
    if (action.type === CREATE_BADGE_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === CREATE_BADGE_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }

    if (action.type === CREATE_BADGE_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const BadgeUpdateReducer = (
  state = initialStateSimple,
  action: any
) => {
  try {
    if (action.type === UPDATE_BADGE_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === UPDATE_BADGE_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }

    if (action.type === UPDATE_BADGE_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const BadgeDeleteReducer = (
  state = initialStateSimple,
  action: any
) => {
  try {
    if (action.type === DELETE_BADGE_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === DELETE_BADGE_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }

    if (action.type === DELETE_BADGE_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const CertificateCriteriaListReducer = (
  state = initialStateSimple,
  action: any
) => {
  try {
    if (action.type === GET_CERTIFICATE_CRITERIA_LIST_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === GET_CERTIFICATE_CRITERIA_LIST_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }

    if (action.type === GET_CERTIFICATE_CRITERIA_LIST_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const CertificateCriteriaByIdReducer = (
  state = initialStateSimple,
  action: any
) => {
  try {
    if (action.type === GET_CERTIFICATE_CRITERIA_BY_ID_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === GET_CERTIFICATE_CRITERIA_BY_ID_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }

    if (action.type === GET_CERTIFICATE_CRITERIA_BY_ID_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const CertificateCriteriaCreateReducer = (
  state = initialStateSimple,
  action: any
) => {
  try {
    if (action.type === CREATE_CERTIFICATE_CRITERIA_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === CREATE_CERTIFICATE_CRITERIA_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }

    if (action.type === CREATE_CERTIFICATE_CRITERIA_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const CertificateCriteriaUpdateReducer = (
  state = initialStateSimple,
  action: any
) => {
  try {
    if (action.type === UPDATE_CERTIFICATE_CRITERIA_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === UPDATE_CERTIFICATE_CRITERIA_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }

    if (action.type === UPDATE_CERTIFICATE_CRITERIA_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const CertificateCriteriaDeleteReducer = (
  state = initialStateSimple,
  action: any
) => {
  try {
    if (action.type === DELETE_CERTIFICATE_CRITERIA_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === DELETE_CERTIFICATE_CRITERIA_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }

    if (action.type === DELETE_CERTIFICATE_CRITERIA_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const CertificateListReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === GET_CERTIFICATE_LIST_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === GET_CERTIFICATE_LIST_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }

    if (action.type === GET_CERTIFICATE_LIST_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: { rows: [], count: 0 },
      };
    }
  } catch (error) {

  }
  return state;
};

export const CertificateCreateReducer = (
  state = initialStateSimple,
  action: any
) => {
  try {
    if (action.type === CREATE_CERTIFICATE_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === CREATE_CERTIFICATE_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }

    if (action.type === CREATE_CERTIFICATE_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const CertificateUpdateReducer = (
  state = initialStateSimple,
  action: any
) => {
  try {
    if (action.type === UPDATE_CERTIFICATE_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === UPDATE_CERTIFICATE_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }

    if (action.type === UPDATE_CERTIFICATE_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const CertificateDeleteReducer = (
  state = initialStateSimple,
  action: any
) => {
  try {
    if (action.type === DELETE_CERTIFICATE_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === DELETE_CERTIFICATE_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }

    if (action.type === DELETE_CERTIFICATE_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const CertificateTemplateUploadReducer = (
  state = initialStateSimple,
  action: any
) => {
  try {
    if (action.type === UPLOAD_CERTIFICATE_TEMPLATE_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === UPLOAD_CERTIFICATE_TEMPLATE_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }

    if (action.type === UPLOAD_CERTIFICATE_TEMPLATE_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};